import { useRef, useState } from "react";
import { Check, Wand2 } from "lucide-react";

import AnchoredPanel from "../shared/AnchoredPanel";
import CustomTooltip from "../Tooltip/CustomTooltip";

const PromptSkillSelector = ({ skills, selectedSkillIds, onToggle }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  if (!skills.length) return null;

  return (
    <>
      <CustomTooltip content="Add skills to this message" side="top" align="center">
        <button
          ref={anchorRef}
          type="button"
          onClick={() => setOpen((current) => !current)}
          aria-label="Choose skills"
          className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${selectedSkillIds.length > 0 ? "bg-fill-positive-surface text-ink-positive-ink dark:bg-fill-positive-surface-dark dark:text-ink-accent" : "bg-fill-navigation-hover text-ink-gray-700 dark:bg-fill-navigation-active dark:text-ink-gray-200"}`}
        >
          <Wand2 size={13} />
          {selectedSkillIds.length > 0 && <span className="text-[11px]">{selectedSkillIds.length}</span>}
        </button>
      </CustomTooltip>
      <AnchoredPanel
        anchorRef={anchorRef}
        isOpen={open}
        onClose={() => setOpen(false)}
        width={240}
        className="overflow-hidden"
      >
        <div className="p-1">
          <div className="border-b border-edge-gray-200 px-3 py-2 text-xs font-semibold text-ink-gray-500 dark:border-edge-panel-border dark:text-ink-gray-400">
            Skills
          </div>
          <div className="max-h-52 overflow-y-auto">
            {skills.map((skill) => {
              const selected = selectedSkillIds.includes(skill.skill_id);
              return (
                <button
                  key={skill.skill_id}
                  type="button"
                  onClick={() => onToggle(skill.skill_id)}
                  className="flex w-full items-center justify-between rounded px-3 py-2 text-left text-sm text-ink-gray-700 hover:bg-fill-gray-100 dark:text-ink-gray-200 dark:hover:bg-fill-gray-700"
                >
                  <span className="min-w-0 pr-2">
                    <span className="block truncate">{skill.display_name}</span>
                    {skill.description && <span className="mt-0.5 block line-clamp-2 text-[10px] leading-4 text-ink-gray-500 dark:text-ink-gray-400">{skill.description}</span>}
                  </span>
                  {selected && <Check className="h-4 w-4 flex-shrink-0 text-ink-teal-600" />}
                </button>
              );
            })}
          </div>
          <p className="border-t border-edge-gray-200 px-3 py-2 text-[11px] leading-4 text-ink-gray-500 dark:border-edge-panel-border dark:text-ink-gray-400">
            Selected skills apply to this message.
          </p>
        </div>
      </AnchoredPanel>
    </>
  );
};

export default PromptSkillSelector;